import { observable, action } from 'mobx';
import { getMessages } from '../apis/MessagesApi';

export default class MessagesStore {
  @observable messages = {};
  @observable messagesLoaded = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  async init() {
    this.getMessages();
  }

  @action
  async getMessages(forceReload = false) {
    if (!forceReload && this.messagesLoaded) {
      return;
    }

    const userLocale = await this.rootStore.localizationStore.getUserLocale();

    try {
      const response = await getMessages(userLocale);
      this.messages = response.data;
      this.setMessagesLoaded();
    } catch (error) {
      console.error(error);

      // Fallback to the defaults and render the application.
      console.warn(
        'Messages file could not be loaded. Falling back to defaults.'
      );
      this.setMessagesLoaded();
    }
  }

  @action
  setMessagesLoaded() {
    this.messagesLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/stores/MessagesStore.js